export default __webpack_public_path__ + "static/media/obito-eye.950fcb99.png";